import { createTheme, loadTheme } from '@fluentui/react';
import { grey } from './defaultTheme';
import { COLOURS } from './widgetColours';
import { p4Tokens } from './p4FluentTheme';

//Configure Fluent UI Theme so components match the rest of the UI.
//TODO - Various incomplete colours that may need filling in going forwards.
loadTheme({
  palette: {
    themePrimary: '#3949ab', //                                 Primary - Background
    themeLighterAlt: '#eff6fc',
    themeLighter: '#deecf9',
    themeLight: '#c7e0f4',
    themeTertiary: '#71afe5',
    themeSecondary: '#2b88d8',
    themeDarkAlt: '#1A237E', //                                 Primary - Hover Background
    themeDark: '#005a9e',
    themeDarker: '#004578',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4', //                               Normal - Hover Background
    neutralLight: '#eaeaea', //                                 Normal - Dropdown Icon Hover Background
    neutralQuaternaryAlt: '#dadada', //Button - Multi Option Button Separator
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#c2c2c2',
    neutralSecondary: '#858585', //Secondary Text (Menu Options)
    neutralPrimaryAlt: '#4b4b4b',
    neutralPrimary: p4Tokens.fieldLabel, //                               Normal - Text Colour
    neutralDark: '#272727', //                                  Normal - Hover Text Colour
    black: p4Tokens.colorNeutralForeground1,
    white: p4Tokens.colorNeutralBackground1, //                                        Normal - Background / Primary - Text
  },
});

export const PrimaryTheme = createTheme({
  palette: {
    themePrimary: '#3949ab', //                                 Primary - Background
    themeDarkAlt: '#1A237E', //                                 Primary - Hover Background
    neutralLighter: grey.dark, //                               Normal - Hover Background
    neutralLight: grey.dark, //                                 Normal - Dropdown Icon Hover Background
    neutralPrimary: '#212B36', //                               Normal - Text Colour
    neutralDark: '#212B36', //                                  Normal - Hover Text Colour
  },
});

//Danger Buttons are red when hovered over.
export const DangerTheme = createTheme({
  palette: {
    neutralPrimary: '#212B36', //Text Colour (Button)
    neutralLighter: '#E3170A', //Hover Background (Button)
    neutralDark: '#fff', //Hover Text Colour (Button)
  },
});

export const WarningTheme = createTheme({
  palette: {
    white: '#ECA400', //Background (Button)
    neutralPrimary: '#fff', //Text Colour (Button)
    neutralLighter: '#DE7F1B', //Hover Background (Button)
    neutralDark: '#ffffff', //Hover Text Colour (Button)
  },
});

export const InfoTheme = createTheme({
  palette: {
    white: grey.base, //Background (Button)
    neutralPrimary: '#212B36', //Text Colour (Button)
    neutralLighter: grey.dark, //Hover Background (Button)
    neutralDark: '#212B36', //Hover Text Colour (Button)
  },
});

//Normal - Looks mostly like 'InfoTheme'
//Primary - Teal colouring.
export const SuccessTheme = createTheme({
  palette: {
    themePrimary: '#00B9AF', //                                 Primary - Background
    themeDarkAlt: '#019e96', //                                 Primary - Hover Background
    neutralLighter: grey.dark, //                               Normal - Hover Background
    neutralLight: grey.dark, //                                 Normal - Dropdown Icon Hover Background
    neutralPrimary: '#212B36', //                               Normal - Text Colour
    neutralDark: '#212B36', //                                  Normal - Hover Text Colour
  },
});

export const SecondaryTheme = createTheme({
  palette: {
    white: '#ffffff', //Background (Button)
    neutralPrimary: '#212B36', //Text Colour (Button)
    neutralLighter: grey.dark, //Hover Background (Button)
    neutralDark: '#ffffff', //Hover Text Colour (Button)
  },
});

//Borderless buttons highlight in the primary colour when the mouse hovers over them.
export const BorderlessTheme = createTheme({
  palette: {
    neutralLighter: '#3949ab', //Hover Background (Button)
    neutralDark: '#ffffff', //Hover Text Colour (Button)
  },
});

//A theme using an extreme colour set to help with configuring themes for fluent components.
export const ActionMenuTheme = createTheme({
  palette: {
    themePrimary: '#3949ab', //Menu Heading
    neutralLighter: '#3949ab', //Hover Background (Button)
    neutralDark: '#fff', //Hover Text Colour (Button)
    neutralLight: '#e0e0e0', //Button - Multi Option Button Background - Selected
    neutralSecondary: '#999999', //Secondary Text (Menu Options)
  },
});

//A theme using an extreme colour set to help with configuring themes for fluent components.
export const TestTheme = createTheme({
  palette: {
    themePrimary: COLOURS[0], //                                  Primary - Background / Underline
    themeLighterAlt: COLOURS[1],
    themeLighter: COLOURS[2],
    themeLight: COLOURS[3],
    themeTertiary: COLOURS[4],
    themeSecondary: COLOURS[5],
    themeDarkAlt: COLOURS[6], //                                  Primary - Hover Background
    themeDark: COLOURS[7],
    themeDarker: COLOURS[8],
    neutralLighterAlt: COLOURS[9],
    neutralLighter: COLOURS[10], //                               Normal - Hover Background / Prefix/Suffix - Background
    neutralLight: COLOURS[11], //                                 Normal - Dropdown Icon Hover Background
    neutralQuaternaryAlt: COLOURS[12], //                         Button - Multi Option Button Separator
    neutralQuaternary: COLOURS[13],
    neutralTertiaryAlt: COLOURS[14],
    neutralTertiary: COLOURS[15],
    neutralSecondary: COLOURS[16], //                             Secondary Text (Menu Options) / Prefix/Suffix - Text Colour
    neutralPrimaryAlt: COLOURS[17],
    neutralPrimary: COLOURS[18], //                               Normal - Text Colour
    neutralDark: COLOURS[19], //                                  Normal - Hover Text Colour
    black: COLOURS[20],
    white: COLOURS[21], //                                        Normal - Background / Primary - Text
  },
});
